import gsap from 'gsap'
import { breakpoint } from 'utility/breakpoints'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

const heroBlock = {
  init(): void {
    gsap.registerPlugin(ScrollTrigger)

    document.querySelectorAll<HTMLElement>('.hero-block').forEach((target: HTMLElement) => {
      this.handleHeroBlock(target)
    })
  },

  handleHeroBlock(target): void {
    const breakpoints = {
      desktop: `(min-width: ${breakpoint.desktop.xs}px) `,
      mobile: `(max-width: ${breakpoint.desktop.xs - 1}px)`,
    }

    const el = {
      block: target,
      photo: target.querySelector('.hero-block__picture'),
      video: target.querySelector('.hero-block__video'),
    }

    const method = {
      init(): void {
        ;[el.photo, el.video].forEach((item) => {
          if (item) {
            method.parallaxImage(item)
          }
        })

        if (el.video) {
          method.handleVideo()
        }
      },

      handleVideo(): void {
        gsap.matchMedia().add(breakpoints, (context) => {
          const is = context.conditions

          if (el.video.querySelector('source')) {
            el.video.querySelector('source').remove()
          }

          const source = document.createElement('source')
          source.setAttribute('type', 'video/mp4')

          if (is.mobile) {
            el.video.setAttribute('poster', el.video.dataset.posterMobile)
            source.src = el.video.dataset.videoMobile
          } else {
            el.video.setAttribute('poster', el.video.dataset.posterDesktop)
            source.src = el.video.dataset.videoDesktop
          }

          setTimeout(() => {
            el.video.appendChild(source)
            el.video.load()
            el.video.currentTime = 0
            el.video.play()

            el.video.classList.add('hero-block__video--loaded')
          }, 12)
        })
      },

      parallaxImage(target): void {
        const triggerParams = {
          end: 'clamp(100% 0%)',
          scrub: true,
          start: 'clamp(0% 100%)',
          trigger: el.block,
        }

        gsap.fromTo(target, { scale: 1 }, { scrollTrigger: triggerParams, scale: 1.1 })
      },
    }

    method.init()
  },
}

export default heroBlock
